import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ProjectAction from "../actions/ProjectAction";
import FieldsSetting from "./FieldsSetting";

export const DataFields = () => {
  const { projectId }: any = useParams();

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (projectId) {
      dispatch(ProjectAction.getProject(projectId));
    }
  }, [projectId, dispatch]);

  useEffect(() => {
    document.title = t("DataFields");
  }, [t]);

  return (
    <div className={"p-4"}>
      <FieldsSetting />
    </div>
  );
};

export default DataFields;
